<template>
    <div>
        <div class="tw:mt-8">
            <h2 class="tw:text-2xl tw:font-bold">
                {{ title }}
            </h2>
            <p class="tw:text-secondary tw:text-sm tw:m-0">
                {{ description }}
            </p>
        </div>

        <div class="tw:bg-gray-100 tw:w-full tw:h-px tw:my-6"></div>

        <ValidationObserver ref="observer" tag="div">
            <div class="tw:max-w-md tw:mx-auto tw:text-center">
                <div class="tw:mb-6">
                    <svg class="tw:mx-auto tw:w-16 tw:h-16 tw:text-primary/60 tw:mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"/>
                    </svg>

                    <!-- Error del backend -->
                    <div
                        v-if="errorMsg"
                        class="tw:mb-4 tw:p-3 tw:bg-red-50 tw:border tw:border-red-200 tw:rounded-lg tw:text-sm tw:text-red-700 tw:text-left"
                    >
                        {{ errorMsg }}
                    </div>

                    <form @submit.prevent="handleSubmit">
                        <BaseInputText
                            v-model="dni"
                            data-cy="dni"
                            label="DNI / NIE"
                            name="dni"
                            rules="required"
                            placeholder="12345678A"
                        />

                        <div class="tw:mt-6">
                            <Button
                                type="submit"
                                :loading="loading"
                                data-cy="buscar-deportista"
                                customClass="tw:w-full tw:justify-center"
                            >
                                Buscar deportista
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script setup>
    import { ref } from 'vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue';

    const props = defineProps({
        title: { type: String, default: 'Buscar deportista' },
        description: { type: String, default: 'Introduce el DNI/NIE del deportista para iniciar la renovación.' },
        loading: { type: Boolean, default: false },
        errorMsg: { type: String, default: '' },
    });

    const emit = defineEmits(['buscar']);

    const observer = ref(null);
    const dni = ref('');

    async function handleSubmit() {
        const isValid = await observer.value.validate();
        if (!isValid) return;
        emit('buscar', dni.value);
    }
</script>
